export type TimeWheelPickerValue = {
  hour: string;
  minute: string;
  period: string;
};

export type TimeWheelPickerColumnType = 'hour' | 'minute' | 'period';
export type TimeWheelPickerSize = 'small' | 'medium' | 'large';
export type TimeWheelPickerVariant = 'default' | 'primary';

export const DEFAULT_TIME_WHEEL_PICKER_VALUE: TimeWheelPickerValue = {
  hour: '',
  minute: '',
  period: ''
};

export const TIME_WHEEL_PICKER_DEFAULTS = {
  SIZE: 'medium',
  VARIANT: 'primary'
} as const;

export const TIME_WHEEL_PICKER_HOURS = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, '0')
);

export const TIME_WHEEL_PICKER_MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, '0')
);

export const TIME_WHEEL_PICKER_PERIODS = ['AM', 'PM'];

export const TIME_WHEEL_PICKER_SNAP_SCROLL_DEBOUNCE_MS = 100;

export const TIME_WHEEL_PICKER_REMOUNT_KEY = {
  LOADING: 'time-wheel-picker-loading',
  READY: 'time-wheel-picker-ready'
} as const;
